import Button from '@ui-kit/components/Button';
import { ModalActions } from '@ui-kit/components/Modal/Modal';
import { useTranslation } from 'react-i18next';
import { AnchorButton } from '@/components/buttons';
import type { ModalProps } from '@/components/ModalRenderer/components/types';
import { Modal } from '@/components/ModalRenderer/Modal';
import { getConfig } from '@/constants/config';
import useWithdrawMutation from '@/pages/Credit/hooks/useWithdrawMutation';

type Payload = { amount: number };
type Props = ModalProps<Payload>;

const WithdrawalFail = ({ closeModal, payload }: Props) => {
  const { t } = useTranslation('Modal');
  const { mutate: withdraw } = useWithdrawMutation();
  const { amount } = payload;

  const handleClick = () => {
    withdraw(amount);
    closeModal();
  };

  return (
    <Modal title={t('WithdrawalFail.title')}>
      <p>{t('WithdrawalFail.info')}</p>
      <ModalActions>
        <Button onClick={handleClick}>{t('WithdrawalFail.tryAgain')}</Button>
        <AnchorButton variant="secondary" href={getConfig().externalLinks.contact}>
          {t('WithdrawalFail.contactUs')}
        </AnchorButton>
      </ModalActions>
    </Modal>
  );
};

export default WithdrawalFail;
